import {Component} from 'react'
import {service} from '../../config/app';
import Api, {Cookie} from '../Shared/Api'
export default class SignApi extends Component{

    constructor(props){
        super(props)
        this.data = {service:'', email:Cookie('meEmail')??'', code:'', phone:Cookie('mePhone')??'', country:Cookie('meCountry')??1, from:1, mode:1}

        this.apiUrl = Api.defaults.baseURL

        this.headers = {            
            'Accept':'application/json',
            'Content-Type':'application/json'
        }
        this.message=""
        this.status=500
    }
    
    static message  

    isEmailReady(value) {
        if(value.length>5 && value.includes("@") && value.includes(".")) {
            const emailRegex = /\S+@\S+\.\S+/;
            if (emailRegex.test(value)) {
                this.data.email = value
                return true
            }
        }
    }

    isPhoneReady(value) {
        if(value.length===10) {
            const phoneRegex = /^\d+$/;
            if (phoneRegex.test(value)) {
                this.data.phone = value
                return true
            }
        }        
    }

    isDataReady(from) {

        this.data.from=from

        if(this.data.mode===1) {
            if(from===2 && this.isPhoneReady(this.data.phone) && this.data.country>0)
                return true
            else if(from===1 && this.isEmailReady(this.data.email))
                return true

        }
        else if(this.data.mode===2 && this.data.code.length===5) {
            return true
        }
    }

    isCode() {
        //const num = /^\d+$/;
        if(this.data.mode===2 && this.data.code.length===5) {
            return true
        }
    }


    async POST(onMode) {

        //console.log('data :', this.data)       
        let response = await fetch(this.apiUrl+ "/signin", {
            method:'POST',
            headers:this.headers,
            body:JSON.stringify(this.data)
        })

        let result = await response.json()
        //console.log('response',result)
        this.status = response.status
        if(response.ok){
           
            if(result?.message) {
                this.message=result.message

                if(this.message.includes("Salaam"))// && result.role)
                {
                    if(this.data.mode===1) {
                        this.data.mode=2
                    }
                    else if(this.data.mode===2 || this.data.from===3) {
                        localStorage.setItem(service.name, JSON.stringify({
                            connected:true, ...result}   
                        ))
                        this.data.mode=3
                    }
                    onMode(this.data.mode)
                    return true
                }
            }
            else {
                this.message="Error api: result message is null?"
            }
        }
        else {
            let result = await response.json()
            this.message = result?.message || "Error api: response invalid?"
        }
        //console.log('Sign message',this.message)
    }

}

